<template>
  <keep-alive include="ShareList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "Share",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
